import type { SVGProps } from 'react';
const SvgDoneWhiteSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.4}
      d="M13.065 3.805a.86.86 0 0 1 .608.253l.056.062a.86.86 0 0 1 .198.547.86.86 0 0 1-.254.606v.001l-7.067 7.061a.864.864 0 0 1-1.222 0L2.59 9.541V9.54a.86.86 0 0 1-.188-.936.9.9 0 0 1 .189-.28.857.857 0 0 1 1.215.001l2.191 2.192 6.459-6.458a.86.86 0 0 1 .608-.254Z"
    />
  </svg>
);
export default SvgDoneWhiteSmall;
